<template>
    <a class="cw-button-hollow cw-button-hollow-primary uk-width-medium" href="#" rel="noopener" target="_blank" @click.prevent="handleButtonClick()">
        <span class="uk-flex uk-flex-middle uk-flex-center">
            <BaseIcon height="20" stroke-width="2" width="20">
                <IconPalette v-if="type === 'scratch'" />
                <IconEraser v-if="type === 'customize'" />
            </BaseIcon>
            &nbsp;{{ text }}
        </span>
    </a>
    <teleport to="body">
        <DesignToolWidthModal v-show="modalOpen === true" @close="closeModal" />
    </teleport>
</template>

<script setup>
import {ref} from 'vue'
import BaseIcon from "../ui/BaseIcon";
import IconPalette from "../icons/IconPalette";
import IconEraser from "../icons/IconEraser";
import DesignToolWidthModal from "./DesignToolWidthModal";

const props = defineProps({
    route: String,
    text: String,
    type: String
})

const modalOpen = ref(false)

function handleButtonClick() {
    let designToolShowWidth = 1000; // screen width below which we dont want to show design tool

    let actualWidth = $(document).width(); // actual screen width

    if (actualWidth < designToolShowWidth) {
        modalOpen.value = true;
    } else {
        window.open(props.route, "_blank");
    }
}

function closeModal() {
    modalOpen.value = false;
}
</script>
